"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Param_1 = tslib_1.__importDefault(require("./Param"));
const includes_1 = tslib_1.__importDefault(require("lodash/includes"));
const isArray_1 = tslib_1.__importDefault(require("lodash/isArray"));
const getFieldComponent_1 = tslib_1.__importDefault(require("./getFieldComponent"));
class Fields extends react_1.default.Component {
    constructor() {
        super(...arguments);
        this.getFieldComponent = (field) => {
            return (0, getFieldComponent_1.default)(field, this.props.getField ?? this.props.getFieldComponent);
        };
    }
    renderFields(params) {
        if (!params)
            return;
        if (Object.keys(params).length === 0)
            return;
        const omit = this.props.omit
            ? (0, isArray_1.default)(this.props.omit)
                ? this.props.omit
                : [this.props.omit]
            : [];
        const only = this.props.only
            ? (0, isArray_1.default)(this.props.only)
                ? this.props.only
                : [this.props.only]
            : [];
        const keys = Object.keys(params)
            .filter(key => {
            if (!only.length)
                return true;
            for (const onlyItem of only) {
                if (onlyItem.startsWith(key))
                    return true;
            }
            return false;
        })
            .filter(key => !(0, includes_1.default)(omit, key));
        return keys.map(key => {
            return (react_1.default.createElement(Param_1.default, { key: key, omit: omit, only: only, field: params[key], fieldName: key, getFieldComponent: this.getFieldComponent, passProps: this.props.passProps }));
        });
    }
    render() {
        return this.renderFields(this.props.params);
    }
}
exports.default = Fields;
Fields.defaultProps = {
    passProps: {}
};
//# sourceMappingURL=index.js.map